export default {
    title: 'factsheets_screen_breakdown_title',
    subtitle: 'factsheets_screen_breakdown_subtitle',
    text: 'factsheets_screen_breakdown_text',
};
